import styled, { css } from 'styled-components';
import { device } from '../../styles/devices';
import { COLORS, SIZING } from '../../styles/variables';

interface StyleProps {
  width?: string;
  height?: string;
  isListOpened?: boolean;
}

export const RadiusSliderWrapper = styled.div`
  padding-top: ${SIZING.unit(3)};
  @media ${device.tablet} {
    padding-top: ${SIZING.unit(3.5)};
  }
  @media (max-width: 926px) and (max-height: 600px) and (orientation: landscape) {
    padding-top: ${SIZING.unit(3)};
  }
`;

export const InfoContainer = styled.div`
  padding: ${SIZING.unit(0)} ${SIZING.unit(3.5)} ${SIZING.unit(5)} ${SIZING.unit(3.5)};
  @media ${device.tablet} {
    padding: ${SIZING.unit(0)} ${SIZING.unit(6)} ${SIZING.unit(6)} ${SIZING.unit(6)};
  }
  @media (max-width: 926px) and (max-height: 600px) and (orientation: landscape) {
    padding: ${SIZING.unit(0)} ${SIZING.unit(4)} ${SIZING.unit(5)} ${SIZING.unit(3)};
    width: 45%;
  }
  ${({ isListOpened }: StyleProps) => {
    if (isListOpened)
      return css`
        padding: ${SIZING.unit(36.5)} ${SIZING.unit(3.5)} ${SIZING.unit(0)} ${SIZING.unit(3.5)};
        padding-bottom: ${SIZING.unit(5)};
        position: relative;
        @media ${device.tablet} {
          padding: ${SIZING.unit(36.5)} ${SIZING.unit(6)} 0 ${SIZING.unit(6)};
          margin-bottom: ${SIZING.unit(5.75)};
        }
        .viewInventoryButton {
          z-index: 100;
          @media (max-width: 926px) and (max-height: 600px) and (orientation: landscape) {
            display: none;
          }
        }
      `;
    return '';
  }}
`;

export const DeaslersControllerWrapper = styled.div`
  position: relative;
  margin-top: ${SIZING.unit(5)};
  margin-bottom: ${SIZING.unit(4.5)};
  @media ${device.tablet} {
    margin-top: ${SIZING.unit(6.5)};
  }
  @media (max-width: 926px) and (max-height: 600px) and (orientation: landscape) {
    margin-top: ${SIZING.unit(4)};
    margin-bottom: ${SIZING.unit(3)};
  }
`;

export const DealerInfoWrapper = styled.div`
  padding-top: ${SIZING.unit(3)};
  @media ${device.tablet} {
    padding-top: ${SIZING.unit(3.5)};
  }
`;

export const CancelButtonWrapper = styled.div`
  position: absolute;
  right: 12px;
  top: 12px;
  z-index: 4;
  width: 32px;
  height: 32px;
  background-color: ${COLORS.white};
  padding: ${SIZING.unit(0)};
  border: none;
  cursor: pointer;
`;
